(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-goals"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-goals-currency')) {
    class CartGoalsCurrency extends HTMLElement {
      connectedCallback() {
        this.updateHandler = this.updateHandler || this.updateCurrency.bind(this);
        queueMicrotask(this.updateHandler);
        window.addEventListener('load', this.updateHandler, { once: true });
      }

      disconnectedCallback() {
        window.removeEventListener('load', this.updateHandler);
      }

      updateCurrency() {
        if (!this.isConnected || this.dataset.converted === 'true') return;
        const currency = this.dataset.currency;
        const shopifyCurrency = window.Shopify && window.Shopify.currency;
        const rate = Number(shopifyCurrency && shopifyCurrency.rate);
        if (!shopifyCurrency || shopifyCurrency.active !== currency || !Number.isFinite(rate) || rate <= 0) return;

        let formatter;
        try {
          formatter = new Intl.NumberFormat(document.documentElement.lang || 'de', {
            style: 'currency', currency
          });
        } catch {
          return;
        }
        const baseGoal = Number(this.dataset.promoBaseGoal);
        const total = Number(this.dataset.cartTotal);
        const shippingGoal = Number(this.dataset.shippingGoal);
        const precision = 10 ** Math.min(2, formatter.resolvedOptions().maximumFractionDigits);
        const currencyStep = 100 / precision;
        const promoGoal = Math.ceil(baseGoal * rate / currencyStep - 1e-8) * currencyStep;
        if (!Number.isFinite(promoGoal) || promoGoal <= 0 || !Number.isFinite(total)) return;

        const message = this.querySelector('[data-currency-promo]');
        const reached = total >= promoGoal;
        const messageTemplate = this.querySelector(reached ? '[data-promo-success-template]' : '[data-promo-deficit-template]');
        const iconTemplate = this.querySelector('[data-promo-icon-template]');
        const track = this.querySelector('.cart-goals__track');
        const bar = track && track.querySelector('.free-shipping-notice__bar');
        if (!message || !messageTemplate || !iconTemplate || !bar) return;

        const content = messageTemplate.content.cloneNode(true);
        const deficit = content.querySelector('[data-promo-deficit]');
        if (deficit) deficit.textContent = formatter.format(Math.max(0, promoGoal - total) / 100);
        message.replaceChildren(content);
        message.dataset.goal = 'promo';
        message.dataset.goalAmount = String(promoGoal);
        const messages = this.querySelector('.cart-goals__messages');
        Array.from(messages.querySelectorAll('[data-goal]'))
          .sort((a, b) => Number(a.dataset.goalAmount) - Number(b.dataset.goalAmount))
          .forEach((node) => messages.appendChild(node));

        const maxGoal = Math.max(shippingGoal, promoGoal);
        const marker = document.createElement('span');
        marker.className = 'cart-goals__milestone cart-goals__milestone--promo';
        marker.classList.toggle('is-reached', reached);
        marker.style.setProperty('--goal-position', `${promoGoal / maxGoal * 100}%`);
        marker.appendChild(iconTemplate.content.cloneNode(true));
        const shippingMarker = bar.querySelector('.cart-goals__milestone--shipping');
        if (shippingMarker) {
          if (shippingGoal === promoGoal) {
            shippingMarker.querySelectorAll('svg').forEach((icon) => marker.appendChild(icon));
            shippingMarker.remove();
          } else {
            shippingMarker.style.setProperty('--goal-position', `${shippingGoal / maxGoal * 100}%`);
          }
        }
        bar.appendChild(marker);
        bar.style.setProperty('--progress', `${Math.min(100, total / maxGoal * 100)}%`);
        track.classList.toggle('cart-goals__track--close', shippingGoal > 0 && shippingGoal !== promoGoal && Math.abs(shippingGoal - promoGoal) / maxGoal < 0.15);
        track.hidden = false;
        this.dataset.converted = 'true';
      }
    }
    customElements.define('cart-goals-currency', CartGoalsCurrency);
  }
  } catch(e) { console.error(e); }
})();

})();
